import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { AccountOwnerSummaryRecord } from "../../../redux/types/reportTypes";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const headers = [
  {
    label: "AM",
    key: "manager",
  },
  {
    label: "UP WTD",
    key: "up_wtd",
  },
  {
    label: "DOWN WTD",
    key: "down_wtd",
  },
  {
    label: "NEUT WTD",
    key: "neutral_wtd",
  },
  {
    label: "WTD ADS",
    key: "wtd_ads",
  },
  {
    label: "WTD DIFF",
    key: "wtd_diff",
  },
  {
    label: "WTD % DIFF",
    key: "wtd_perc_diff",
  },
  {
    label: "UP MTD",
    key: "up_mtd",
  },
  {
    label: "DOWN MTD",
    key: "down_mtd",
  },
  {
    label: "NEUT MTD",
    key: "neutral_mtd",
  },
  {
    label: "MTD ADS",
    key: "mtd_ads",
  },
  {
    label: "MTD DIFF",
    key: "mtd_diff",
  },
  {
    label: "MTD % DIFF",
    key: "mtd_perc_diff",
  },
  {
    label: "UP QTD",
    key: "up_qtd",
  },
  {
    label: "DOWN QTD",
    key: "down_qtd",
  },
  {
    label: "NEUT QTD",
    key: "neutral_qtd",
  },
  {
    label: "QTD ADS",
    key: "qtd_ads",
  },
  {
    label: "QTD DIFF",
    key: "qtd_diff",
  },
  {
    label: "QTD % DIFF",
    key: "qtd_perc_diff",
  },
];

type AccountCSVProps = {
  data: Array<AccountOwnerSummaryRecord>;
};

const AccountCSV = ({ data }: AccountCSVProps): ReactElement => (
  <CSVLink data={data} headers={headers}>
    <Button type="dashed" icon={<FileExcelOutlined />} />
  </CSVLink>
);

export default AccountCSV;
